<template>
  <v-app>
    <h2 v-if="user">
      <a href="#">Log out</a>
    </h2>
    <v-app-bar app dark>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title v-text="$route.name"></v-toolbar-title>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer"  app>
    <v-list-item>
        <v-list-item-title class="text-h6">
            Hockenbergs Directory
          </v-list-item-title>
        <v-list-item-content>
          
          <!-- <v-list-item-subtitle>
            subtext
          </v-list-item-subtitle> -->
        </v-list-item-content>
        
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item>
        <v-list-item-content>
          <v-select :items="branches" v-model="selectedBranch"></v-select>
        </v-list-item-content>
        
      </v-list-item>
      <v-divider></v-divider>
      <v-list nav dense>
        <v-list-item-group
          v-model="group"
        >
          <v-list-item to="/">
            
            <v-list-item-title>Directory</v-list-item-title>
          </v-list-item>

          <v-list-item to="/vendors" v-if="user">
            <v-list-item-title>Vendor Information</v-list-item-title>
          </v-list-item>
          <v-list-item to="/mfg-prefix" v-if="user">
            
            <v-list-item-title>Manufacturer Prefix List</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item v-on:click.stop="logOut()" v-if="user">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Log Out</v-list-item-title>
          </v-list-item> -->
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <router-view :pdf-api-ready="pdfAPIReady"></router-view>
    </v-main>
    <vue-snotify></vue-snotify>
  </v-app>
</template>

<script>
import { msalMixin } from 'vue-msal'; 

export default {
  name: "App",
  mixins: [msalMixin],
  components: {},

  data: () => ({
    drawer: false,
    group: null,
    pdfAPIReady:false,
    selectedBranch:null,
    branches:[
      {value:'01',text:'Omaha'},
      {value:'02',text:'Lincoln'},
      {value:'03',text:'Austin'},
      {value:'04',text:'Des Moines'},
      {value:'05',text:'Minneapolis'},
      {value:'06',text:'Kansas City'},
      {value:'07',text:'Atlanta'},
      {value:'08',text:'Denver'},
      {value:'09',text:'Plymouth'},
      {value:'30',text:'NRD'},
      {value:'40',text:'RG Cabinets'},
    ]
  }),
  // provide() {
  //   // use function syntax so that we can access `this`
  //   return {
  //     pdfAPIReady: computed(() => this.pdfAPIReady)
  //   }
  // },
  watch: {
    IDToken(v) {
      this.$http.defaults.headers.common["Authorization"] ="Bearer " + v;
    }
  },
  computed: {
    user() {
          let user = null;
          if (this.msal.isAuthenticated) { // Note that the dollar sign ($) is missing from this.msal
            user = {
              ...this.msal.user,
              profile: {}
            }
            if (this.msal.graph && this.msal.graph.profile) {
                user.profile = this.msal.graph.profile
            }
          }
          return user;
        },
        IDToken() {
          if (this.$_.isString(this.msal.idToken) && this.msal.idToken.length>20) return this.msal.idToken
          var tmp =localStorage.getItem("adal.idtoken")

          return tmp;
    }
  },
  methods: {
    
  },
  mounted() {
    if(this.IDToken) {
      this.$http.defaults.headers.common["Authorization"] ="Bearer " + this.IDToken;
    }
  },
  created() {
    if(window.AdobeDC) {
      this.pdfAPIReady = true;
    } else {
      document.addEventListener("adobe_dc_view_sdk.ready", () => { this.pdfAPIReady = true; });
    }
  }
};
</script>

<style scoped>
header {
  background: rgb(2,0,36);
background: linear-gradient(100deg, rgba(2,0,36,1) 0%, rgba(204,0,0,1) 35%, rgba(255,255,255,0.4210728236607143) 100%);
}
</style>